module.exports = __webpack_public_path__ + "img/0x14Ab1f697Fa9F616f32167a009FE056AD90814B4.f9f98b34.png";